
export function runOtherThread(fn: ()=>void|Promise<void>) {
  setTimeout(fn)
}

export function waitMilis(n: number) {
  return new Promise<void>(res => {
    setTimeout(() => res(), n)
  })
}
